import {TrackingManagerV1} from '@volkswagen-onehub/tracking-service'
import {Global} from './variables'
import store from '../app/store'

let localTrackingManager: TrackingManagerV1

export const setTrackingServiceManager = (
    trackingManager: TrackingManagerV1
) => {
    localTrackingManager = trackingManager
}

export enum TrackingAction {
    VW_BASIC_LINK_CLICK = 'VWBasic_Link_Click',
    VW_BASIC_FILTER_SELECT_CLICK = 'VWBasic_FilterSelect_Click',
    VW_BASIC_FILTER_SEARCH_RESULT_LOAD = 'VWBasic_FilterSearchResult_Load',
    VW_BASIC_VEHICLE_BUTTON_CLICK = 'VWBasic_VehicleButton_Click',
    VW_BASIC_VEHICLE_LINK_CLICK = 'VWBasic_VehicleLink_Click',
    VW_BASIC_LAYER_LOAD = 'VWBasic_Layer_Load',
}

export const trackingData = {
    APP_VARIANT: 'var.1',
    BRAND: 'passenger',
    COMMERCE: false,
    PERSONALIZATION: 'false',
    PAGE_CATEGORY: 'Area Clienti',
    MULTI_VALUE: 'multi_value',
    RANGE: 'range',
}

export const eventInfoCommon = {
    brand: trackingData.BRAND,
    pageCategory: trackingData.PAGE_CATEGORY,
}

export const trackingEvent = (event: string, configuration?: any) => {
    const serviceType = store.getState().general.serviceType

    if (!localTrackingManager) {
        return
    }

    return localTrackingManager.track(event, {
        environment: {
            featureAppVariant: serviceType,
        },
        personalization: {
            status: trackingData.PERSONALIZATION,
        },
        ...configuration,
    })
}

export const layerLoadTracking = (contentId: string) => {
    trackingEvent(TrackingAction.VW_BASIC_LAYER_LOAD, {
        eventInfo: {
            ...eventInfoCommon,
            contentId,
        },
    })
}

export const selectTracking = (
    title: string,
    type: string,
    values: number | number[] | string | (string | string[])[]
) => {
    trackingEvent(TrackingAction.VW_BASIC_FILTER_SELECT_CLICK, {
        eventInfo: {
            ...eventInfoCommon,
            contentId: title,
        },
        filter: {
            type: type,
            name: title,
            values: values,
        },
    })
}
export const vehicleTracking = (
    type: string,
    model: string,
    version: string,
    monthlyPayment: string,
    ctaUrl: string,
    ctaText: string,
    simulationId?: string
) => {
    const modelName = `${model} ${version}`

    trackingEvent(
        type === Global.BUTTON
            ? TrackingAction.VW_BASIC_VEHICLE_BUTTON_CLICK
            : TrackingAction.VW_BASIC_VEHICLE_LINK_CLICK,
        {
            eventInfo: {
                ...eventInfoCommon,
            },
            configuration: {
                CarlineName: model,
                SalesgroupName: type === Global.BUTTON ? version : undefined,
                ModelName: type === Global.BUTTON ? modelName : undefined,
                PriceRateBasic: monthlyPayment,
            },
            link: {
                url:
                    type === Global.BUTTON
                        ? ctaUrl
                        : `${ctaUrl}/#${simulationId}`,
                name:
                    type === Global.BUTTON
                        ? ctaText
                        : `${ctaText}${Global.STRING_SEPARATOR}${model}${Global.STRING_SEPARATOR}${version}${Global.STRING_SEPARATOR}${monthlyPayment}${Global.EURO}`,
            },
            calculation: {},
        }
    )
}
